import { useCallback, useEffect, useState } from 'react';
import { MappedVehicleType, VehicleFromApiType } from '../../types';
import { useAppContext } from '../../../../../contexts/auth';
import useApiCall from '../../../../../hooks/useApiCall';
import VehiclesService from '../../../../../services/affreightment/VehiclesService';
import { toast } from 'react-toastify';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';

export default function useLoadVehicles() {
  const [vehicles, setVehicles] = useState<MappedVehicleType[]>([]);
  const [apiFetched, setApiFetched] = useState(true);
  const [isLoadLoading, setIsLoadLoading] = useState(false);

  const { selectedCompany } = useAppContext();
  const { companyCode, userCode, userProfile } = useGetGeneralAppData();

  const { apiCall } = useApiCall();

  const roles = {
    Ônibus: <small>Ônibus</small>,
    Van: <small className="green">Van</small>,
    Micro: <small className="orange">Micro</small>,
    Outros: <small className="gray">Outros</small>,
  };

  const loadVehicles = useCallback(async () => {
    await apiCall({
      apiToCall: VehiclesService.listVehicles,
      queryParams: { codEmpresa: companyCode, codUsu: userCode, perfilUsu: userProfile },
      onStartLoad: () => setIsLoadLoading(true),
      onEndLoad: () => setIsLoadLoading(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível carregar a lista de veículos (${response.msg})`);
          setApiFetched(false);
          return;
        }
        const vehicleList: VehicleFromApiType[] = response.veiculos;
        const mappedVehicles = vehicleList?.map((vehicle) => ({
          vehicleId: vehicle.codVeiculoSis,
          model: vehicle.modelo,
          transportTypeCode: vehicle.CodtipoTransp,
          transportType: vehicle.tipoTransporte,
          vehicleCode: vehicle.codVeiculo,
          brand: vehicle.marca,
          capacity: vehicle.capacidade,
          consumption: vehicle.consumo,
          qrCode: vehicle.qRCode,
        }));

        setVehicles(mappedVehicles);
        setApiFetched(true);
      },
      catchAction: () => setApiFetched(false),
      catchMessage: 'Não foi possível carregar a lista de veículos. Por favor, tente novamente',
    });
  }, [apiCall, companyCode, userCode, userProfile]);

  useEffect(() => {
    if (companyCode) {
      loadVehicles();
    }
  }, [companyCode, loadVehicles]);

  function handleTryAgain() {
    loadVehicles();
  }

  return {
    userProfile,
    isLoadLoading,
    companyCode,
    vehicles,
    apiFetched,
    handleTryAgain,
    roles,
    selectedCompany,
    loadVehicles,
  };
}
